import { Dispatch } from 'redux'

import api from 'common/api'

import { MicroSurveyState, MicroSurveyTag, MicroSurveyTypes } from '.'

interface MicroSurveyTagResponse {
  Tags: MicroSurveyTag[]
}

const fetchMicroSurveyTags = () => (dispatch: Dispatch<any>) => {
  return api
    .get<MicroSurveyTagResponse>('/api/micro_survey/tags?type=unfollow')
    .then((response) => {
      dispatch(
        updateUnfollowSurveyTags({
          unfollowTags: response.Tags,
        }),
      )
    })
    .catch(() => {})
}
const updateUnfollowSurveyTags = (newValue: MicroSurveyState) => {
  return {
    type: MicroSurveyTypes.UPDATE_MICROSURVEY_UNFOLLOW_TAGS,
    payload: newValue,
  }
}

const actions = {
  updateUnfollowSurveyTags,
  fetchMicroSurveyTags,
}

export default actions
